<template>
  <v-layout row wrap>
    <v-flex lg6 md6 sm12 xs12>
      <v-container>
        <div class="panel-heading">
          Add Feature
        </div>
        <div class="panel-body">
          <form class="form-horizontal" @submit.prevent="postFeature()">
            <div class="row">
              <div class="form-group col-md-10" style="margin-left: 5%">
                <label class="control-label">Name</label>

                <div class=""><input v-model="feature.name" type="text" placeholder="Name..." class="form-control"></div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-10" style="margin-left: 5%">
                <label class="control-label">Url</label>

                <div class=""><input v-model="feature.url" type="text" placeholder="Name..." class="form-control"></div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-10" style="margin-left: 5%">
                <label class="control-label">Description</label>

                <div class="">
                  <textarea v-model="feature.description"  cols="30" rows="10" class="form-control"></textarea>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="col-sm-8 col-sm-offset-1">
                <button class="btn btn-primary" type="submit">Add Menu</button>
              </div>
            </div>
          </form>
        </div>
      </v-container>
    </v-flex>
    <v-flex lg6 md6 sm12 xs12>
      <v-container>
        <div class="panel-heading">
          Current Features
        </div>
        <div class="panel-body">
          <div class="table-responsive">
            <table cellpadding="1" cellspacing="1" class="table table-bordered">
              <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Url</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(menu, index) in allFeatures" :key="index">
                <td>{{index + 1}}</td>
                <td>{{menu.name}}</td>
                <td>{{menu.url}}</td>
                <td>
                  <!--<button class="btn btn-sm btn-info" @click="getFeatures(menu.public_id)">Assign Features</button>-->
                  <!--<button class="btn btn-sm btn-warning" @click="deleteMenu(menu.public_id)">Disable</button>-->
                </td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'features',
  data () {
    return {
      feature: {
        url: '',
        name: '',
        description: '',
        menu_public_id: this.$route.params.menu_id
      }
    }
  },
  created () {
    this.$store.dispatch('get_m_features', this.$route.params.menu_id)
  },
  methods: {
    postFeature: function () {
      this.$store.dispatch('post_m_feature', this.feature)
    }
  }
}
</script>

<style scoped>

</style>
